import {
  Box,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import InputContainer from "../../../components/InputContainer";

const Settings = ({ formik }) => {
  return (
    <>
      <InputContainer
        title={"Settings"}
        icon={"/images/layout/setting.svg"}
        sx={{
          my: 1,
        }}
      >
        <RadioGroup
          name="videoPause"
          value={formik.values.videoPause}
          row
          onChange={(value, e) => {
            formik.handleChange(value);
          }}
          sx={{ display: "flex", pt: 1, width: 1 }}
        >
          <Grid container>
            <Grid item xs={12} md={12}>
              <Typography
                sx={{ color: "#aaaaaa" }}
                fontWeight={500}
                variant="body1"
              >
                Video status when the feature appears
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <FormControlLabel
                value={false}
                control={<Radio color="info" />}
                label={
                  <Box>
                    <Typography variant="subtitle2" color={"#5B5B5B"}>
                      Continue
                    </Typography>
                  </Box>
                }
              />

              <FormControlLabel
                value={true}
                control={<Radio color="info" />}
                label={
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Typography variant="subtitle2" color={"#5B5B5B"}>
                      Stop
                    </Typography>
                  </Box>
                }
              />
            </Grid>
          </Grid>
        </RadioGroup>
        <RadioGroup
          name="position"
          value={formik.values.position}
          row
          onChange={(value, e) => {
            formik.handleChange(value);
          }}
          sx={{ display: "flex", width: 1 }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <FormControlLabel
                value={1}
                control={<Radio color="info" />}
                label={
                  <Box>
                    <Typography variant="subtitle2" color={"#5B5B5B"}>
                      Right
                    </Typography>
                  </Box>
                }
              />

              <FormControlLabel
                value={2}
                control={<Radio color="info" />}
                label={
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Typography variant="subtitle2" color={"#5B5B5B"}>
                      Left
                    </Typography>
                  </Box>
                }
              />
              <FormControlLabel
                value={3}
                control={<Radio color="info" />}
                label={
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Typography variant="subtitle2" color={"#5B5B5B"}>
                      Mid
                    </Typography>
                  </Box>
                }
              />
            </Grid>
          </Grid>
        </RadioGroup>
        <Typography sx={{ color: "#aaaaaa" }} fontWeight={500} variant="body1">
          How long does the feature last?
        </Typography>
        <InputContainer
          title={"Enter the duration of the appearance"}
          sx={{
            my: 1,
          }}
        >
          <TextField
            fullWidth
            type="number"
            name="duration"
            value={formik.values.duration}
            onChange={formik.handleChange}
            placeholder={"Enter the duration of the appearance ex.10 in sec"}
            variant="standard"
            error={formik.touched.duration && Boolean(formik.errors.duration)}
            helperText={formik.touched.duration && formik.errors.duration}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </InputContainer>
      </InputContainer>
    </>
  );
};

export default Settings;
